import { Signature } from './signature';

export class Application {
    applicationID: number;
    userID: number ;
    contactName: string ;
    applicationStatusID: number ;
    applicationDate: string ;
    user:Signature;
    constructor(app ?: any) {
        this.user = new Signature();
        if(app){
            this.userID = (app.userID ?  app.userID : undefined);
            this.applicationID = (app.applicationID ?  app.applicationID : 0);
            this.contactName = (app.contactName ?  app.contactName : '');
            this.applicationStatusID = (app.applicationStatusID ?  app.applicationStatusID : undefined);
            this.applicationDate = (app.applicationDate ?  app.applicationDate : JSON.stringify(new Date()));
            this.user.signature = (app.signature ? app.signature : 0)
        }

    }

}
